import rest from "@/utils/rest";
export default {
  GetReportInitData() {
    let link = "ReportAdmin/GetUsedCodesInitData";
    return rest
      .channel(link, {
        method: "GET",
      })
      .then((response) => rest.promiseInterceptor(response));
  },

  GetReportData: (
    PolicyNumber,
    CarNumber,
    UserID,
    CarWashID,
    ServiceID,
    StartSendDate,
    EndSendDate,
    StartAppoveDate,
    EndAppoveDate,
    CodeStatus,
    fordownload
  ) => {
    let params = "?";
    params += "PolicyNumber=" + (PolicyNumber ? PolicyNumber : "");
    params += "&CarNumber=" + (CarNumber ? CarNumber : "");
    params += "&UserID=" + (UserID ? UserID : "");
    params += "&CarWashID=" + (CarWashID ? CarWashID : "");
    params += "&ServiceID=" + (ServiceID ? ServiceID : "");
    params += "&StartSendDate=" + (StartSendDate ? StartSendDate : "");
    params += "&EndSendDate=" + (EndSendDate ? EndSendDate : "");
    params += "&StartAppoveDate=" + (StartAppoveDate ? StartAppoveDate : "");
    params += "&EndAppoveDate=" + (EndAppoveDate ? EndAppoveDate : "");
    params += "&EndAppoveDate=" + (EndAppoveDate ? EndAppoveDate : "");
    params += "&CodeStatus=" + (CodeStatus ? CodeStatus : "0");
    params += "&ForDownload=" + (fordownload ? true : false);
    let link = "ReportAdmin/GetUsedCodes" + params;
    if (fordownload) {
      rest.channelFile(link, {
        method: "GET",
      });
    } else {
      return rest
        .channel(link, {
          method: "GET",
        })
        .then((response) => rest.promiseInterceptor(response));
    }
  }
  
};
